<template>
  <div>
    <vxe-menu ref="menu" :options="list" accordion size="mini" @click="onClick"/>
  </div>
</template>

<script>
import { findAll } from '@/api/Api'

export default {
  name: 'MenuTree',
  data() {
    return {
      loading: false,
      list: [],
      currentMenu: {}
    }
  },
  methods: {
    onClick({ currentMenu }) {
      this.currentMenu = currentMenu
      this.$emit('getDetail', currentMenu.itemKey)
    },
    buildMenuTree(items, parentId = undefined) {
      return items.filter(item => parentId ? parentId === item.parent?.id : item.parent == null).map(item => ({
        name: item.id,
        title: item.name,
        children: this.buildMenuTree(items, item.id)
      }))
    },
    fetch() {
      this.loading = true
      findAll('menuFactory', {}).then(res => {
        if (res.success) {
          this.list = this.buildMenuTree(res.result)
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.fetch()
    }
  }
}
</script>